import React from "react";

const Savedproject = () => {
	return <div>Savedproject</div>;
};

export default Savedproject;
